import LOGIN from "../symbols/login";
import { HttpRequestPostForLogin } from "../../service";

const shopLoginAction = (payload: any) => ({
  type: LOGIN.LOGIN,
  payload,
});

const shopLoginSuccessAction = (data: any) => ({
  type: LOGIN.LOGIN_SUCCESS,
  payload: {
    data,
    isUserAdmin: false,
  },
});

const shopLoginFailureAction = (data: any) => ({
  type: LOGIN.LOGIN_FAILURE,
  payload: {
    data,
    isUserAdmin: false,
  },
});

const clearshopLoginAction = () => ({
  type: LOGIN.CLEAR_LOGIN,
});

export function merchantLogin(Email: string, Password: string) {
  return (dispatch: any) => {
    dispatch(shopLoginAction({ Email }));
    HttpRequestPostForLogin(
      "/portal/login",
      dispatch,
      shopLoginSuccessAction,
      shopLoginFailureAction,
      false,
      {
        //request body
        Email,
        Password,
      }
    );
  };
}

// Updated shopLogin to work with the new authentication system
export function shopLogin(authResponse: any) {
  return (dispatch: any) => {
    // Dispatch success action directly with the auth response
    const action = shopLoginSuccessAction({
      role: authResponse.Role,
      shopName: authResponse.ShopName,
      merchantName: authResponse.MerchantName,
      merchantLogoUrl: authResponse.MerchantLogoUrl,
      isCollectEnabled: authResponse.IsCollectEnabled,
      isCollectOnly: authResponse.IsCollectOnly,
      termsAccepted: authResponse.TermsAccepted
    });
    
    dispatch(action);
  };
}

export function clearShopLogin() {
  return (dispatch: any) => {
    dispatch(clearshopLoginAction());
  };
}
